import { configureStore } from '@reduxjs/toolkit';
import tournamentReducer from './tournamentSlice';
import clockReducer from './clockSlice';
import playersReducer from './playersSlice';
import settingsReducer from './settingsSlice';
import { createSessionMiddleware } from './sessionMiddleware';

export const store = configureStore({
  reducer: {
    tournament: tournamentReducer,
    clock: clockReducer,
    players: playersReducer,
    settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'tournament/setStartTime', 
          'tournament/setEndTime',
          'tournament/createTournament',
          'tournament/loadTournament',
          'players/addPlayer',
          'players/addPlayers',
          'players/loadPlayers',
          'players/eliminatePlayer',
        ],
        ignoredPaths: [
          'tournament.current.state.startTime',
          'tournament.current.state.endTime',
          'tournament.current.createdAt',
          'tournament.current.updatedAt',
          'players.players',
        ],
        ignoredActionsPaths: ['payload.timeOut', 'payload.createdAt', 'payload.updatedAt'],
      },
    }).concat(createSessionMiddleware()),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;